module.exports = __webpack_public_path__ + "static/media/ycp_logo.a49ada79.svg";